export default __webpack_public_path__ + "static/media/1_0004.08eec882.webp";